export default "__VITE_ASSET__zd8$Y2eI__"